<div class="members">
  <div class="members__header">
    <div *ngIf="!!(unionsUsers.length + telegramUsers.length)" class="header">
      <app-icon class="icon" [src]="'users'" [size]="'32px'"></app-icon>

      <div class="title">
        {{
          (!!memberCount
            ? (memberCount
              | numeralPlurals
                : [
                    'components.usersList.labels.memberOne' | translate,
                    'components.usersList.labels.memberFew' | translate,
                    'components.usersList.labels.memberMany' | translate,
                  ])
            : unionsUsers || telegramUsers
              ? (unionsUsers.length + telegramUsers.length
                | numeralPlurals
                  : [
                      'components.usersList.labels.memberOne' | translate,
                      'components.usersList.labels.memberFew' | translate,
                      'components.usersList.labels.memberMany' | translate,
                    ])
              : '') +
            (inviteUsers.length
              ? ' (' +
                (inviteUsers.length
                  | numeralPlurals
                    : [
                        'components.usersList.labels.invitedMemberOne' | translate,
                        'components.usersList.labels.invitedMemberFew' | translate,
                        'components.usersList.labels.invitedMemberMany' | translate,
                      ]) +
                ')'
              : '')
        }}
      </div>

      <button
        *ngIf="
          !env.isBot &&
          currentUserChatStatus &&
          (currentUserChatStatus._ === 'chatMemberStatusCreator' ||
            (currentUserChatStatus._ === 'chatMemberStatusRestricted' &&
              currentUserChatStatus.permissions.canInviteUsers) ||
            (currentUserChatStatus._ === 'chatMemberStatusAdministrator' && currentUserChatStatus.canInviteUsers) ||
            (currentUserChatStatus._ === 'chatMemberStatusMember' && chatPermissions?.canInviteUsers))
        "
        tuiIconButton
        class="button"
        type="button"
        appearance="icon"
        iconStart="@tui.circle-plus"
        size="s"
        [tuiHint]="'common.buttons.add' | translate"
        (click)="openSearchMembersDialog()"
      ></button>
    </div>
  </div>

  <tui-scrollbar class="members__list">
    <tui-loader [inheritColor]="true" [overlay]="true" [showLoader]="!(unionsUsers || telegramUsers) || loading">
      <!-- Список пользователей ассоциации, которые уже являются участниками чата -->
      <ng-container *ngIf="!!unionsUsers.length">
        <p class="users-list-group__title">{{ 'components.usersList.labels.title' | translate }}</p>
        <app-list
          listType="users"
          [items]="unionsUsers"
          (selectedIdChange)="onSelectedIdChangeUnionsUsers($event)"
        ></app-list>

        <p *ngIf="!!isChannel && !!memberCount && memberCount > 200" class="users-list-group__hint">
          {{ 'components.usersList.labels.hint' | translate }}
        </p>
      </ng-container>

      <!-- Список пользователей ассоциации, которым отправлены приглашения -->
      <div *ngIf="inviteUsers.length" class="users-list-group">
        <p class="users-list-group__title">{{ 'components.usersList.labels.inviteUsers' | translate }}</p>
        <app-list
          listType="users"
          [items]="inviteUsers"
          (selectedIdChange)="onSelectedIdChangeInviteUsers($event)"
        ></app-list>
      </div>

      <!-- Список пользователей telegram, которые не входят в ассоциацию -->
      <div *ngIf="telegramUsers.length" class="users-list-group">
        <p class="users-list-group__title">{{ 'components.usersList.labels.telegramUsers' | translate }}</p>
        <app-list listType="users" [items]="telegramUsers"></app-list>
      </div>
    </tui-loader>
  </tui-scrollbar>
</div>
